import { Chip } from '@heroui/react';
import { EProductType } from '@quesmed/types/models';
import { BiSearch } from 'react-icons/bi';
import { CalendarInput, SearchInput, SearchTextArea, Select, Switch } from '@/core/ui';
import { useComment } from '@/store/comment';
import { getSelectItem, getStartAndEndOfDayUnix } from '@/utils';
import { stringToNumberArr } from '@/utils/string';

const quesProducts = getSelectItem(EProductType, [
  EProductType.MEDICAL_SCIENCES,
  EProductType.ANATOMY,
  EProductType.QBANK,
  EProductType.MSRA,
  EProductType.PLAB1,
  EProductType.MRCP_PART1,
  EProductType.MRCP_PART2,
]);

export const FiltersSection = () => {
  const questionIds = useComment.use.questionIds();
  const search = useComment.use.search();
  // const createdAt = useComment.use.createdAt();
  const productId = useComment.use.productId();
  const review = useComment.use.review();
  const setQuestionIds = useComment.use.setQuestionIds();
  const setSearch = useComment.use.setSearch();
  // const setCreatedAt = useComment.use.setCreatedAt();
  const setProductId = useComment.use.setProductId();
  const setReview = useComment.use.setReview();
  const resetFilters = useComment.use.resetFilters();
  const hasFilters = useComment.use.hasFilters();
  const setDateFilter = useComment.use.setDateFilter();
  const setDateRange = useComment.use.setDateRange();
  const dateRange = useComment.use.dateRange();
  const setRange = useComment.use.setRange();

  const onProductFilter = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const val = e.target.value as unknown as EProductType;
    setProductId(val ? Number(val) : null);
  };

  // const handleDateChange = (value: CalendarDate | CalendarDateTime | ZonedDateTime | null | undefined) => {
  //   setCreatedAt(value || undefined);
  // };

  const handleDateFilterChange = (value: any) => {
    if (value?.selectedFilter) {
      setDateFilter(value.selectedFilter);
    }

    setDateRange(value);
    if (!value.start) {
      setRange({ from: null, to: null });
      return;
    }
    const values = getStartAndEndOfDayUnix(value);
    setRange(values);
  };

  return (
    <div className='bg-background rounded-lg shadow-md p-4'>
      <div className='flex items-center justify-between mb-4'>
        <h1 className='text-lg font-medium text-default-700'>Filters</h1>
        {hasFilters() && (
          <Chip variant='bordered' onClose={() => resetFilters()}>
            Reset
          </Chip>
        )}
      </div>

      <div className='flex flex-wrap gap-4 items-end'>
        <SearchInput
          isClearable
          type='search'
          className='w-64'
          placeholder='Search comments...'
          startContent={<BiSearch />}
          classNames={{ inputWrapper: 'h-12' }}
          variant='faded'
          value={search}
          onClear={() => setSearch('')}
          onValueChange={(value) => setSearch(value)}
        />

        <SearchTextArea
          placeholder='Question Ids (comma separated)'
          labelPlacement='outside'
          value={questionIds.join(', ')}
          onValueChange={(value) => setQuestionIds(stringToNumberArr(value))}
          variant='faded'
          className='w-64'
          maxRows={1}
          size='lg'
        />

        {/* <DatePicker className='w-56' size='lg' value={createdAt} onChange={handleDateChange} variant='faded' /> */}

        <Select
          size='lg'
          options={quesProducts}
          selectedKeys={productId != null ? [`${productId}`] : undefined}
          onChange={onProductFilter}
          popoverProps={{ classNames: { content: ' !p-1.5 !w-48' } }}
          classNames={{ listbox: '!p-0', innerWrapper: '!capitalize' }}
          placeholder='Product'
          name='product'
          className='rounded w-56'
          variant='faded'
        />

        <CalendarInput
          size='lg'
          selectedFilter={null}
          // className={cn(isMobile ? 'w-full' : 'w-auto')}
          onChange={handleDateFilterChange}
          value={dateRange?.start ? { start: dateRange.start, end: dateRange.end } : undefined}
        />

        <div className='flex items-center gap-2 bg-default-100 rounded-lg p-2 w-44 h-12 border border-default-200'>
          <Switch
            isSelected={review === true}
            onValueChange={(isSelected) => setReview(isSelected ? true : null)}
            size='sm'
            color='secondary'
          >
            <span className='text-sm text-default-700'>Review Only</span>
          </Switch>
        </div>
      </div>
    </div>
  );
};
